import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useParams, useNavigate } from "react-router-dom";
import "./../../../assets/css/popup.css";

import { uploadImageServer } from "../../../apis/newsApi";
import {
  createDocumentsDynamic,
  getDocumentsDynamic,
  updateDocumentsDynamic,
} from "../../../apis/AllDocuments";
import { getAppProducts } from "../../../apis/AppProductsApi";
import langauge from "../../../lib/common/languages.json";
import { DynamicDocumentsValidations } from "../../../Validations/AllDocumentsValidations";

export default function AddNewDocuments() {
  const [loading, setLoading] = useState(false);
  const [loader, setLoader] = useState(false);
  const [productList, setProductList] = useState([]);

  const navigate = useNavigate();
  const { id } = useParams();

  const [initialValues, setInitialValues] = useState({
    title: "",
    language: "",
    sort: "",
    url: "",
    crmProductId: "",
  });

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const res = await getAppProducts();
      setProductList(res?.result || []);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  useEffect(() => {
    if (id) {
      fetchDocumentDetails(id);
    }
  }, [id]);

  const fetchDocumentDetails = async (id) => {
    setLoader(true);
    try {
      const res = await getDocumentsDynamic(id);
      if (res?.result) {
        setInitialValues({
          title: res.result.name || "",
          sort: res.result.sort || "",
          url: res?.result?.files?.[0]?.filePath || "",
          language: res.result.language || "",
          crmProductId: res.result.crmProductId || "",
        });
      }
    } catch (error) {
      console.error("Error fetching document:", error);
    } finally {
      setLoader(false);
    }
  };

  const formik = useFormik({
    initialValues,
    // validationSchema: DynamicDocumentsValidations,
    enableReinitialize: true,
    onSubmit: async (values) => {
      console.log(values, "values on submit");
      setLoading(true);
      try {
        const payload = {
          ...values,
          files: values.url ? [{ filePath: values.url }] : [],
          type: "document",
        };

        delete payload.url;

        if (id) {
          await updateDocumentsDynamic(id, payload);
        } else {
          await createDocumentsDynamic(payload);
        }

        navigate("/documents-list");
      } catch (error) {
        console.error("Error submitting form:", error);
      } finally {
        setLoading(false);
      }
    },
  });

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    try {
      const upload = await uploadImageServer(formData);
      formik.setFieldValue("url", upload.path);
    } catch (error) {
      console.error("Error uploading document:", error);
    }
  };

  const backClick = () => navigate("/documents-list");

  return (
    <div className="main-wrapper">
      <div className="page-wrapper">
        <div className="content container-fluid">
          <i
            className="fas fa-arrow-left"
            style={{ fontSize: "20px", cursor: "pointer" }}
            onClick={backClick}
          />

          <div className="my-3 p-3 bg-body rounded shadow-sm">
            <h3>{id ? "Edit" : "Add"} Document</h3>

            {loader ? (
              <div>Loading...</div>
            ) : (
              <form onSubmit={formik.handleSubmit} className="formMaxwidth">
                {/* <div className="input-block mb-3">
                  <label className="col-form-label">Sort Order</label>
                  <input
                    type="number"
                    className="form-control"
                    name="sort"
                    value={formik.values.sort}
                    onChange={formik.handleChange}
                  />
                </div> */}

                <div className="input-block mb-3">
                  <label className="col-form-label">Title *</label>
                  <input
                    type="text"
                    className="form-control"
                    name="title"
                    value={formik.values.title}
                    onChange={formik.handleChange}
                  />
                  {formik.errors.title && formik.touched.title && (
                    <span className="text-danger">{formik.errors.title}</span>
                  )}
                </div>

                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Upload Document (PDF)
                  </label>

                  <input
                    type="file"
                    accept=".pdf"
                    className="form-control mb-2"
                    onChange={handleFileUpload}
                  />

                  <input
                    type="text"
                    className="form-control"
                    placeholder="Or paste document URL"
                    name="url"
                    value={formik.values.url}
                    onChange={formik.handleChange}
                  />

                  {formik.values.url && (
                    <a
                      href={formik.values.url}
                      target="_blank"
                      rel="noreferrer"
                      className="d-block mt-2"
                    >
                      View Document
                    </a>
                  )}
                  {formik.errors.url && formik.touched.url && (
                    <span className="text-danger">{formik.errors.url}</span>
                  )}
                </div>

                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Product <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="crmProductId"
                    value={formik.values.crmProductId}
                    onChange={formik.handleChange}
                  >
                    <option value="">Select Product</option>
                    {productList.map((p) => (
                      <option key={p.id} value={p.crmProductId}>
                        {p.name}
                      </option>
                    ))}
                  </select>
                  {formik.errors.crmProductId &&
                    formik.touched.crmProductId && (
                      <span className="text-danger">
                        {formik.errors.crmProductId}
                      </span>
                    )}
                </div>

                {/* <div className="input-block mb-3">
                  <label className="col-form-label">Language *</label>
                  <select
                    className="form-select"
                    name="language"
                    value={formik.values.language}
                    onChange={formik.handleChange}
                  >
                    <option value="">Select Language</option>
                    <option value="en">English</option>
                    <option value="de">German</option>
                  </select>
                </div> */}
                <div className="input-block mb-3">
                  <label className="col-form-label">Language *</label>

                  <select
                    className="form-select"
                    name="language"
                    value={formik.values.language}
                    onChange={formik.handleChange}
                  >
                    <option value="">Select Language</option>

                    {langauge.map((lang) => (
                      <option key={lang.code} value={lang.code}>
                        {lang.label}
                      </option>
                    ))}
                  </select>
                  {formik.errors.language && formik.touched.language && (
                    <span className="text-danger">
                      {formik.errors.language}
                    </span>
                  )}
                </div>
                <div className="input-block mb-3">
                  <label className="col-form-label">Sort Order</label>
                  <input
                    type="number"
                    className="form-control"
                    name="sort"
                    value={formik.values.sort}
                    onChange={formik.handleChange}
                  />
                  {formik.errors.sort && formik.touched.sort && (
                    <span className="text-danger">{formik.errors.sort}</span>
                  )}
                </div>

                <div className="mt-4">
                  <button
                    className="btn btn-primary"
                    type="submit"
                    disabled={loading}
                  >
                    {loading ? "Saving..." : id ? "Update" : "Submit"}
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
